export const routes = {
  home: '/',
  quiz: '/quiz',
  newPlanPaywall: '/new-plan-paywall',
  paymentSuccess: '/payment-success',
  superYouthUpgradeSucceeded: '/upgrade-success',
  youthPremium: '/youth-premium',
};
